import axios from 'axios';
import { PendoConfiguration } from '../common/interfaces/PathsConfiguration';

declare global {
    interface Window {
        pendo: pendo.Pendo;
    }
}

export class PendoService {
    constructor(private readonly configService: PendoConfiguration) {}

    public async initializePendoForAuthenticatedUser(pendoAuthenticateType: PendoAuthenticateType): Promise<void> {
        const url = pendoAuthenticateType.urlBase + '/PendoService/v1/metadata';
        const pendoConfig: pendo.InitOptions = {
            apiKey: this.configService.pendoApiKey
        };
        try {
            const response = await axios.get(url, {
                withCredentials: true,
                headers: {
                    'Ocp-Apim-Subscription-Key': pendoAuthenticateType.apimKey
                }
            });
            if (response.data) {
                pendoConfig.visitor = response.data;
                pendoConfig.account = {
                    id: response.data.clientId,
                    name: response.data.clientName
                };
            }
        } catch (error: unknown) {
            console.error('Failed to initialize Pendo with user context', error);
        }

        window.pendo && window.pendo.initialize(pendoConfig);
    }

    public initializePendoForPathsInitialize(pathsPendoInitializeType: PathsPendoInitializeType): void {
        window.pendo &&
            window.pendo.initialize({
                apiKey: this.configService.pendoApiKey,
                account: {
                    id: pathsPendoInitializeType.clientId,
                    name: pathsPendoInitializeType.clientName
                }
            });
    }
}

export interface PendoAuthenticateType {
    urlBase: string;
    apimKey: string;
}

export interface PathsPendoInitializeType {
    clientId: string;
    clientName: string;
}
